import { render } from "./SC_Report.vue?vue&type=template&id=e51eda64"
import script from "./SC_Report.vue?vue&type=script&lang=js"
export * from "./SC_Report.vue?vue&type=script&lang=js"

import "./SC_Report.vue?vue&type=style&index=0&id=e51eda64&lang=css"

import exportComponent from "C:\\Users\\sisco\\Documents\\Compras\\SC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__